import Layout from '@components/layout';
import { BREAKPOINTS } from '@consts/ui';
import useProfile from '@hooks/useProfile';
import useReduxState from '@hooks/useReduxState';
import { useCallback, useState } from 'react';
import Achievements from './components/achievements';
import Affiliates from './components/affiliates';
import ProfileTab from './components/profile-tab';
import ProfileTabs from './components/profile-tabs';
import styles from './profile.module.scss';

export const PROFILE_TAB = 0;
export const ACHIEVEMENTS_TAB = 1;
export const SETTINGS_TAB = 2;
export const AFFILIATE_TAB = 3;

export type TUserProfileTabs = typeof PROFILE_TAB | typeof ACHIEVEMENTS_TAB | typeof SETTINGS_TAB | typeof AFFILIATE_TAB;

export const userProfileTabs = [
  {
    title: 'Profile',
    element: <ProfileTab />,
  },
  {
    title: 'Achievements',
    element: <Achievements />,
  },
  {
    title: 'Settings',
    element: <></>,
  },
  {
    title: 'Affiliates',
    element: <Affiliates />,
  },
];

export default function UserProfile(): JSX.Element {
  const user = useProfile();
  const [{ windowWidth }] = useReduxState((state) => state.ui);
  const [currentTab, setCurrentTab] = useState<TUserProfileTabs>(PROFILE_TAB);

  const isMobile = windowWidth <= BREAKPOINTS.LG;

  const changeTab = useCallback(
    (tab: TUserProfileTabs) => {
      setCurrentTab(tab);
    },
    [user]
  );

  return (
    <Layout title={user.username}>
      <div className={styles.profile}>
        {!isMobile ? (
          <>
            <ProfileTabs currentTab={currentTab} changeTab={changeTab} />
            <div className={styles.content}>{userProfileTabs[currentTab].element}</div>
          </>
        ) : (
          <div className={styles.content}>{userProfileTabs[currentTab].element}</div>
        )}
      </div>
    </Layout>
  );
}
